import { Consent } from '@sky-distribution/digital-gp-submission';
import { mapConsentsByStatus } from '@sky-distribution/gp-onboarding-shared-utils';
import { Submission } from '../service/Policy.service.type';

export const getSubmissionConsents = (
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
): { consents_SKY: Consent[] } => {
  return {
    consents_SKY: mapConsentsByStatus(consentStatus, consentDictionary),
  };
};

export const getSubmissionWithConsents = (
  submission: Submission,
  consentStatus: Record<string, boolean>,
  consentDictionary: Consent[],
): Submission => ({
  ...submission,
  baseData: {
    ...submission.baseData,
    ...getSubmissionConsents(consentStatus, consentDictionary),
  },
});
